import React, { useState } from 'react';
import SweetAlert from 'sweetalert2';
import CONTRACT_LIST from '../contracts/contractList';

/** Sends an item as Gift from one Wallet to another.
 * @param {*} tokenId Item token ID
 * @param {*} contract Contract worker | shipe
 * @param {*} userAddress Wallet ID
 */
export const giftAsset = async (tokenId, contract, userAddress) => {

  // const savedWallets = window.localStorage.getItem('wallets') !== null
  //   ? window.localStorage.getItem('wallets')
  //   : window.localStorage.setItem('wallets', []);

  // //console.log('savedWallets: ', savedWallets);

  if(contract._address == CONTRACT_LIST['SPACESHIP_CONTRACT']) {
    const TRANSFER_TIME = 0
    const transferCooldown = parseInt(await contract.methods.getTokenCooldown(tokenId).call({from: userAddress}));
    let now = parseInt((Date.now() / 1000).toFixed(0));
    if(transferCooldown > (now-TRANSFER_TIME) ) {
      SweetAlert.fire({
        title: 'Spaceship on the garage',
        text: 'Your Spaceship has a transfer cooldown.',
        footer: '<center><span class="txt-danger">You can transfer your Spaceship between accounts once every 24 hours.</span></center>',
        icon: 'error',
      });
      return;
    }
  }



  SweetAlert.fire({
    title: 'Who will receive this NFT? ',
    icon: 'question',
    input: 'text',
    confirmButtonText: 'Proceed',
    footer: '<span class="txt-danger"><center>We can’t recover NFT sent to wrong addresses. <br><b>Please Double Check.</b></center></span>',
  }).then(async (result) => {
    if (result.value) {
      await contract.methods.safeTransferFrom(userAddress, result.value, tokenId).send({ from: userAddress });

      SweetAlert.fire({
        title: '¡Nice!',
        text: 'Your gift was sent. 😊 ',
        icon: 'success',
      });
    }
  });
};
